import { createAsyncThunk } from "@reduxjs/toolkit"
import { coreActions } from "../slices/core.slice"
import { authorizedGet } from "../utils/api"
import { hideShellLoader, navigateTo401 } from "../utils/dom"
import { getAppConfig } from "./config.thunks"

export const getPendingEulas = createAsyncThunk(
  "core/getPendingEulas",
  async (originalAction: any, { dispatch }) => {
    const { userToken, userResponse } = originalAction.payload
    try {
      const res = await authorizedGet("/api/eulas/pending", userToken)

      if (res && res.length > 0) {
        dispatch(
          coreActions.setPendingEulas({
            pendingEulas: res,
            token: userToken,
            userResponse
          })
        )
        hideShellLoader()
      } else if (res === null || res?.length === 0) {
        dispatch(coreActions.setPendingEulas(null))
        if (userResponse) {
          dispatch(coreActions.setUserInfo(userResponse))
          dispatch(getAppConfig(undefined))
        }
      } else {
        navigateTo401({ dispatch })
      }
    } catch {
      navigateTo401({ dispatch })
    }
  }
)
